import React from 'react';
import ReactDOM from 'react-dom';
import { MonitoringBoundary } from '@web-monitoring/react';
import { setup } from '@xp-hub-permission/react';
import { Config } from 'utils/permissions';

setup({ env: Config.env });

const monitoringOptions = {
  release: process.env.RELEASE_NAME,
  env: process.env.RELEASE_ENV,
  errors: { projectId: '1792825', projectKey: '4da431bbbefb4f4699e7a19211eaa563' },
  performance: { projectId: '375686482' },
};

(async () => {
  const startReactApp = () => {
    import('./App').then((component) => {
      const App = component.default;
      ReactDOM.render(<App />, document.getElementById('app'));
    });
  };

  if (window.xpSession && window.xpSession.complete) { startReactApp(); }
  window.document.addEventListener('TOKEN_LOADED', () => { startReactApp(); });
})();



// WEBPACK FOOTER //
// ./src/index.js